export interface IPointData
{
    x: number;
    y: number;
}

/**
 * Common interface for points. Both Point and ObservablePoint implement it
 * @memberof PIXI
 * @interface IPointData
 */

/**
 * X coord
 * @memberof PIXI.IPointData#
 * @member {number} x
 */

/**
 * Y coord
 * @memberof PIXI.IPointData#
 * @member {number} y
 */
